<template>
  <div class="references">
    <a href="https://shimo.im/docs/MKI47rfGgw4a7CSg" target="_blank">计算规则</a>
  </div>
</template>

<script>
export default {
  methods: {
  }
};
</script>

<style lang="postcss" scoped>
.references {
  margin: 0 0 140px;
  font-size: 12px;
  a {
    color: hsl(200, 60%, 45%);
    text-decoration: underline;
  }
}
</style>
